// code from https://github.com/jden/objectid/tree/1.1.0

const $3_BITS = 0xffffff;
const $5_BITS = 0xffffffffff;

const MACHINE_ID_AND_PID = Math.round(Math.random() * $5_BITS);
let index = 0;

const nextIndex = () => {
  index = index + (1 % $3_BITS);
  return index;
};

const currentTimestamp = () => Math.floor(new Date().getTime() / 1000);

const pad = (value, padAmount) => {
  while (value.length < padAmount) {
    value = "0" + value;
  }
  return value;
};

const makeObjectId = () => {
  /* ObjectIds
   * 24 character hex strings of 12 byte objects
   * 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | A | B
   * Timestamp     | Machine   | PID   | Index
   * Since we're running in a browser, we just use random values
   * for Machine and PID
   */

  const groups = [
    // [value, padding in hex (bytes * 2)]
    [currentTimestamp(), 8],
    [MACHINE_ID_AND_PID, 10],
    [nextIndex(), 6],
  ];

  const str = groups.reduce(
    (id, group) => id + pad(group[0].toString(16), group[1]),
    ""
  );

  return str;
};

const objIdPattern = /^[0-9a-fA-F]{24}$/;
const isValid = (alleged) =>
  !!alleged &&
  typeof alleged.toString === "function" &&
  objIdPattern.test(alleged.toString());

export { isValid, makeObjectId };
